import E1 from "react";
import { SvgIcon as n } from "@material-ui/core";
var X = { exports: {} }, Z = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var H1;
function le() {
  if (H1)
    return Z;
  H1 = 1;
  var r = E1, B = Symbol.for("react.element"), U = Symbol.for("react.fragment"), H = Object.prototype.hasOwnProperty, W = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, T = { key: !0, ref: !0, __self: !0, __source: !0 };
  function R(j, f, V) {
    var L, M = {}, g = null, S = null;
    V !== void 0 && (g = "" + V), f.key !== void 0 && (g = "" + f.key), f.ref !== void 0 && (S = f.ref);
    for (L in f)
      H.call(f, L) && !T.hasOwnProperty(L) && (M[L] = f[L]);
    if (j && j.defaultProps)
      for (L in f = j.defaultProps, f)
        M[L] === void 0 && (M[L] = f[L]);
    return { $$typeof: B, type: j, key: g, ref: S, props: M, _owner: W.current };
  }
  return Z.Fragment = U, Z.jsx = R, Z.jsxs = R, Z;
}
var _ = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var V1;
function ae() {
  return V1 || (V1 = 1, process.env.NODE_ENV !== "production" && function() {
    var r = E1, B = Symbol.for("react.element"), U = Symbol.for("react.portal"), H = Symbol.for("react.fragment"), W = Symbol.for("react.strict_mode"), T = Symbol.for("react.profiler"), R = Symbol.for("react.provider"), j = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), V = Symbol.for("react.suspense"), L = Symbol.for("react.suspense_list"), M = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), Q = Symbol.iterator, w1 = "@@iterator";
    function I1(o) {
      if (o === null || typeof o != "object")
        return null;
      var t = Q && o[Q] || o[w1];
      return typeof t == "function" ? t : null;
    }
    var E = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(o) {
      {
        for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
          i[s - 1] = arguments[s];
        B1("error", o, i);
      }
    }
    function B1(o, t, i) {
      {
        var s = E.ReactDebugCurrentFrame, a = s.getStackAddendum();
        a !== "" && (t += "%s", i = i.concat([a]));
        var d = i.map(function(l) {
          return String(l);
        });
        d.unshift("Warning: " + t), Function.prototype.apply.call(console[o], console, d);
      }
    }
    var R1 = !1, m1 = !1, b1 = !1, Z1 = !1, _1 = !1, e1;
    e1 = Symbol.for("react.module.reference");
    function W1(o) {
      return !!(typeof o == "string" || typeof o == "function" || o === H || o === T || _1 || o === W || o === V || o === L || Z1 || o === S || R1 || m1 || b1 || typeof o == "object" && o !== null && (o.$$typeof === g || o.$$typeof === M || o.$$typeof === R || o.$$typeof === j || o.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      o.$$typeof === e1 || o.getModuleId !== void 0));
    }
    function T1(o, t, i) {
      var s = o.displayName;
      if (s)
        return s;
      var a = t.displayName || t.name || "";
      return a !== "" ? i + "(" + a + ")" : i;
    }
    function r1(o) {
      return o.displayName || "Context";
    }
    function x(o) {
      if (o == null)
        return null;
      if (typeof o.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof o == "function")
        return o.displayName || o.name || null;
      if (typeof o == "string")
        return o;
      switch (o) {
        case H:
          return "Fragment";
        case U:
          return "Portal";
        case T:
          return "Profiler";
        case W:
          return "StrictMode";
        case V:
          return "Suspense";
        case L:
          return "SuspenseList";
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case j:
            var t = o;
            return r1(t) + ".Consumer";
          case R:
            var i = o;
            return r1(i._context) + ".Provider";
          case f:
            return T1(o, o.render, "ForwardRef");
          case M:
            var s = o.displayName || null;
            return s !== null ? s : x(o.type) || "Memo";
          case g: {
            var a = o, d = a._payload, l = a._init;
            try {
              return x(l(d));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var y = Object.assign, m = 0, o1, n1, t1, i1, s1, c1, l1;
    function a1() {
    }
    a1.__reactDisabledLog = !0;
    function S1() {
      {
        if (m === 0) {
          o1 = console.log, n1 = console.info, t1 = console.warn, i1 = console.error, s1 = console.group, c1 = console.groupCollapsed, l1 = console.groupEnd;
          var o = {
            configurable: !0,
            enumerable: !0,
            value: a1,
            writable: !0
          };
          Object.defineProperties(console, {
            info: o,
            log: o,
            warn: o,
            error: o,
            group: o,
            groupCollapsed: o,
            groupEnd: o
          });
        }
        m++;
      }
    }
    function P1() {
      {
        if (m--, m === 0) {
          var o = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: y({}, o, {
              value: o1
            }),
            info: y({}, o, {
              value: n1
            }),
            warn: y({}, o, {
              value: t1
            }),
            error: y({}, o, {
              value: i1
            }),
            group: y({}, o, {
              value: s1
            }),
            groupCollapsed: y({}, o, {
              value: c1
            }),
            groupEnd: y({}, o, {
              value: l1
            })
          });
        }
        m < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var $ = E.ReactCurrentDispatcher, Y;
    function P(o, t, i) {
      {
        if (Y === void 0)
          try {
            throw Error();
          } catch (a) {
            var s = a.stack.trim().match(/\n( *(at )?)/);
            Y = s && s[1] || "";
          }
        return `
` + Y + o;
      }
    }
    var N = !1, A;
    {
      var A1 = typeof WeakMap == "function" ? WeakMap : Map;
      A = new A1();
    }
    function d1(o, t) {
      if (!o || N)
        return "";
      {
        var i = A.get(o);
        if (i !== void 0)
          return i;
      }
      var s;
      N = !0;
      var a = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var d;
      d = $.current, $.current = null, S1();
      try {
        if (t) {
          var l = function() {
            throw Error();
          };
          if (Object.defineProperty(l.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(l, []);
            } catch (p) {
              s = p;
            }
            Reflect.construct(o, [], l);
          } else {
            try {
              l.call();
            } catch (p) {
              s = p;
            }
            o.call(l.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (p) {
            s = p;
          }
          o();
        }
      } catch (p) {
        if (p && s && typeof p.stack == "string") {
          for (var c = p.stack.split(`
`), v = s.stack.split(`
`), u = c.length - 1, C = v.length - 1; u >= 1 && C >= 0 && c[u] !== v[C]; )
            C--;
          for (; u >= 1 && C >= 0; u--, C--)
            if (c[u] !== v[C]) {
              if (u !== 1 || C !== 1)
                do
                  if (u--, C--, C < 0 || c[u] !== v[C]) {
                    var k = `
` + c[u].replace(" at new ", " at ");
                    return o.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", o.displayName)), typeof o == "function" && A.set(o, k), k;
                  }
                while (u >= 1 && C >= 0);
              break;
            }
        }
      } finally {
        N = !1, $.current = d, P1(), Error.prepareStackTrace = a;
      }
      var I = o ? o.displayName || o.name : "", y1 = I ? P(I) : "";
      return typeof o == "function" && A.set(o, y1), y1;
    }
    function O1(o, t, i) {
      return d1(o, !1);
    }
    function D1(o) {
      var t = o.prototype;
      return !!(t && t.isReactComponent);
    }
    function O(o, t, i) {
      if (o == null)
        return "";
      if (typeof o == "function")
        return d1(o, D1(o));
      if (typeof o == "string")
        return P(o);
      switch (o) {
        case V:
          return P("Suspense");
        case L:
          return P("SuspenseList");
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case f:
            return O1(o.render);
          case M:
            return O(o.type, t, i);
          case g: {
            var s = o, a = s._payload, d = s._init;
            try {
              return O(d(a), t, i);
            } catch {
            }
          }
        }
      return "";
    }
    var D = Object.prototype.hasOwnProperty, u1 = {}, C1 = E.ReactDebugCurrentFrame;
    function F(o) {
      if (o) {
        var t = o._owner, i = O(o.type, o._source, t ? t.type : null);
        C1.setExtraStackFrame(i);
      } else
        C1.setExtraStackFrame(null);
    }
    function F1(o, t, i, s, a) {
      {
        var d = Function.call.bind(D);
        for (var l in o)
          if (d(o, l)) {
            var c = void 0;
            try {
              if (typeof o[l] != "function") {
                var v = Error((s || "React class") + ": " + i + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw v.name = "Invariant Violation", v;
              }
              c = o[l](t, l, s, i, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (u) {
              c = u;
            }
            c && !(c instanceof Error) && (F(a), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", s || "React class", i, l, typeof c), F(null)), c instanceof Error && !(c.message in u1) && (u1[c.message] = !0, F(a), h("Failed %s type: %s", i, c.message), F(null));
          }
      }
    }
    var U1 = Array.isArray;
    function q(o) {
      return U1(o);
    }
    function $1(o) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, i = t && o[Symbol.toStringTag] || o.constructor.name || "Object";
        return i;
      }
    }
    function Y1(o) {
      try {
        return f1(o), !1;
      } catch {
        return !0;
      }
    }
    function f1(o) {
      return "" + o;
    }
    function h1(o) {
      if (Y1(o))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $1(o)), f1(o);
    }
    var b = E.ReactCurrentOwner, N1 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, v1, L1, z;
    z = {};
    function q1(o) {
      if (D.call(o, "ref")) {
        var t = Object.getOwnPropertyDescriptor(o, "ref").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return o.ref !== void 0;
    }
    function z1(o) {
      if (D.call(o, "key")) {
        var t = Object.getOwnPropertyDescriptor(o, "key").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return o.key !== void 0;
    }
    function G1(o, t) {
      if (typeof o.ref == "string" && b.current && t && b.current.stateNode !== t) {
        var i = x(b.current.type);
        z[i] || (h('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', x(b.current.type), o.ref), z[i] = !0);
      }
    }
    function J1(o, t) {
      {
        var i = function() {
          v1 || (v1 = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        i.isReactWarning = !0, Object.defineProperty(o, "key", {
          get: i,
          configurable: !0
        });
      }
    }
    function K1(o, t) {
      {
        var i = function() {
          L1 || (L1 = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        i.isReactWarning = !0, Object.defineProperty(o, "ref", {
          get: i,
          configurable: !0
        });
      }
    }
    var X1 = function(o, t, i, s, a, d, l) {
      var c = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: B,
        // Built-in properties that belong on the element
        type: o,
        key: t,
        ref: i,
        props: l,
        // Record the component responsible for creating this element.
        _owner: d
      };
      return c._store = {}, Object.defineProperty(c._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(c, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: s
      }), Object.defineProperty(c, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: a
      }), Object.freeze && (Object.freeze(c.props), Object.freeze(c)), c;
    };
    function Q1(o, t, i, s, a) {
      {
        var d, l = {}, c = null, v = null;
        i !== void 0 && (h1(i), c = "" + i), z1(t) && (h1(t.key), c = "" + t.key), q1(t) && (v = t.ref, G1(t, a));
        for (d in t)
          D.call(t, d) && !N1.hasOwnProperty(d) && (l[d] = t[d]);
        if (o && o.defaultProps) {
          var u = o.defaultProps;
          for (d in u)
            l[d] === void 0 && (l[d] = u[d]);
        }
        if (c || v) {
          var C = typeof o == "function" ? o.displayName || o.name || "Unknown" : o;
          c && J1(l, C), v && K1(l, C);
        }
        return X1(o, c, v, a, s, b.current, l);
      }
    }
    var G = E.ReactCurrentOwner, k1 = E.ReactDebugCurrentFrame;
    function w(o) {
      if (o) {
        var t = o._owner, i = O(o.type, o._source, t ? t.type : null);
        k1.setExtraStackFrame(i);
      } else
        k1.setExtraStackFrame(null);
    }
    var J;
    J = !1;
    function K(o) {
      return typeof o == "object" && o !== null && o.$$typeof === B;
    }
    function M1() {
      {
        if (G.current) {
          var o = x(G.current.type);
          if (o)
            return `

Check the render method of \`` + o + "`.";
        }
        return "";
      }
    }
    function ee(o) {
      {
        if (o !== void 0) {
          var t = o.fileName.replace(/^.*[\\\/]/, ""), i = o.lineNumber;
          return `

Check your code at ` + t + ":" + i + ".";
        }
        return "";
      }
    }
    var x1 = {};
    function re(o) {
      {
        var t = M1();
        if (!t) {
          var i = typeof o == "string" ? o : o.displayName || o.name;
          i && (t = `

Check the top-level render call using <` + i + ">.");
        }
        return t;
      }
    }
    function p1(o, t) {
      {
        if (!o._store || o._store.validated || o.key != null)
          return;
        o._store.validated = !0;
        var i = re(t);
        if (x1[i])
          return;
        x1[i] = !0;
        var s = "";
        o && o._owner && o._owner !== G.current && (s = " It was passed a child from " + x(o._owner.type) + "."), w(o), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', i, s), w(null);
      }
    }
    function j1(o, t) {
      {
        if (typeof o != "object")
          return;
        if (q(o))
          for (var i = 0; i < o.length; i++) {
            var s = o[i];
            K(s) && p1(s, t);
          }
        else if (K(o))
          o._store && (o._store.validated = !0);
        else if (o) {
          var a = I1(o);
          if (typeof a == "function" && a !== o.entries)
            for (var d = a.call(o), l; !(l = d.next()).done; )
              K(l.value) && p1(l.value, t);
        }
      }
    }
    function oe(o) {
      {
        var t = o.type;
        if (t == null || typeof t == "string")
          return;
        var i;
        if (typeof t == "function")
          i = t.propTypes;
        else if (typeof t == "object" && (t.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        t.$$typeof === M))
          i = t.propTypes;
        else
          return;
        if (i) {
          var s = x(t);
          F1(i, o.props, "prop", s, o);
        } else if (t.PropTypes !== void 0 && !J) {
          J = !0;
          var a = x(t);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", a || "Unknown");
        }
        typeof t.getDefaultProps == "function" && !t.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ne(o) {
      {
        for (var t = Object.keys(o.props), i = 0; i < t.length; i++) {
          var s = t[i];
          if (s !== "children" && s !== "key") {
            w(o), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", s), w(null);
            break;
          }
        }
        o.ref !== null && (w(o), h("Invalid attribute `ref` supplied to `React.Fragment`."), w(null));
      }
    }
    function g1(o, t, i, s, a, d) {
      {
        var l = W1(o);
        if (!l) {
          var c = "";
          (o === void 0 || typeof o == "object" && o !== null && Object.keys(o).length === 0) && (c += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var v = ee(a);
          v ? c += v : c += M1();
          var u;
          o === null ? u = "null" : q(o) ? u = "array" : o !== void 0 && o.$$typeof === B ? (u = "<" + (x(o.type) || "Unknown") + " />", c = " Did you accidentally export a JSX literal instead of a component?") : u = typeof o, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", u, c);
        }
        var C = Q1(o, t, i, a, d);
        if (C == null)
          return C;
        if (l) {
          var k = t.children;
          if (k !== void 0)
            if (s)
              if (q(k)) {
                for (var I = 0; I < k.length; I++)
                  j1(k[I], o);
                Object.freeze && Object.freeze(k);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              j1(k, o);
        }
        return o === H ? ne(C) : oe(C), C;
      }
    }
    function te(o, t, i) {
      return g1(o, t, i, !0);
    }
    function ie(o, t, i) {
      return g1(o, t, i, !1);
    }
    var se = ie, ce = te;
    _.Fragment = H, _.jsx = se, _.jsxs = ce;
  }()), _;
}
process.env.NODE_ENV === "production" ? X.exports = le() : X.exports = ae();
var e = X.exports;
const Ce = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "AccountLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M2.5 14.5V12.5C2.5 11.3954 3.39543 10.5 4.5 10.5H11.5C12.6046 10.5 13.5 11.3954 13.5 12.5V14.5M10.5 5C10.5 6.38071 9.38071 7.5 8 7.5C6.61929 7.5 5.5 6.38071 5.5 5C5.5 3.61929 6.61929 2.5 8 2.5C9.38071 2.5 10.5 3.61929 10.5 5Z",
        stroke: "currentColor",
        strokeLinecap: "round"
      }
    )
  }
), fe = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "AccountHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M3 14V12C3 10.8954 3.89543 10 5 10H11C12.1046 10 13 10.8954 13 12V14M10 5C10 6.10457 9.10457 7 8 7C6.89543 7 6 6.10457 6 5C6 3.89543 6.89543 3 8 3C9.10457 3 10 3.89543 10 5Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
      }
    )
  }
), he = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "AccountDropdownLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M2.50006 14.5V12.5C2.50006 11.3954 3.39549 10.5 4.50006 10.5H11.5001M10.5001 5C10.5001 6.38071 9.38077 7.5 8.00006 7.5C6.61935 7.5 5.50006 6.38071 5.50006 5C5.50006 3.61929 6.61935 2.5 8.00006 2.5C9.38077 2.5 10.5001 3.61929 10.5001 5ZM12.8549 14.785L14.6373 12.748C14.7787 12.5863 14.6639 12.3333 14.4491 12.3333H10.8843C10.6695 12.3333 10.5548 12.5863 10.6962 12.748L12.4786 14.785C12.5782 14.8988 12.7553 14.8988 12.8549 14.785Z",
        stroke: "currentColor",
        strokeLinecap: "round"
      }
    )
  }
), ve = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "AccountDropdownHeavy",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M2 14C2 14.5523 2.44772 15 3 15C3.55228 15 4 14.5523 4 14H2ZM4 14V12H2V14H4ZM5 11H12V9H5V11ZM9 5C9 5.55229 8.55228 6 8 6V8C9.65685 8 11 6.65685 11 5H9ZM8 6C7.44772 6 7 5.55228 7 5H5C5 6.65685 6.34315 8 8 8V6ZM7 5C7 4.44772 7.44772 4 8 4V2C6.34315 2 5 3.34315 5 5H7ZM8 4C8.55228 4 9 4.44771 9 5H11C11 3.34315 9.65685 2 8 2V4ZM12 11H14C14 9.89543 13.1046 9 12 9V11ZM4 12C4 11.4477 4.44772 11 5 11V9C3.34315 9 2 10.3431 2 12H4Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M14.5329 12H11.4671C11.2675 12 11.1484 12.2225 11.2591 12.3887L12.792 14.688C12.8909 14.8364 13.1091 14.8364 13.208 14.688L14.7409 12.3887C14.8516 12.2225 14.7325 12 14.5329 12Z",
          fill: "currentColor"
        }
      )
    ]
  }
), Le = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "AccountsLight",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M1.5 13.5V12.5C1.5 11.3954 2.39543 10.5 3.5 10.5H7.5C8.60457 10.5 9.5 11.3954 9.5 12.5V13.5M9.5 8.5H12.5C13.6046 8.5 14.5 9.39543 14.5 10.5V11.5M7.5 5.5C7.5 6.60457 6.60457 7.5 5.5 7.5C4.39543 7.5 3.5 6.60457 3.5 5.5C3.5 4.39543 4.39543 3.5 5.5 3.5C6.60457 3.5 7.5 4.39543 7.5 5.5Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M12.5 5C12.5 5.82843 11.8284 6.5 11 6.5C10.1716 6.5 9.5 5.82843 9.5 5C9.5 4.17157 10.1716 3.5 11 3.5C11.8284 3.5 12.5 4.17157 12.5 5Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), ke = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "AccountsHeavy",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M1 14V12C1 10.8954 1.89543 10 3 10H9C10.1046 10 11 10.8954 11 12V14M8 5C8 6.10457 7.10457 7 6 7C4.89543 7 4 6.10457 4 5C4 3.89543 4.89543 3 6 3C7.10457 3 8 3.89543 8 5Z",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M13 3C13 3.55228 12.5523 4 12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3Z",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M11 7H13C14.1046 7 15 7.89543 15 9V9.99997",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      )
    ]
  }
), Me = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "AlertStatusLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M7.49994 9.5V6.5M7.49994 11.5V11.4933M12.7763 12.0528L8.39437 3.28885C8.02584 2.55181 6.97404 2.55181 6.60551 3.28885L2.22355 12.0528C1.8911 12.7177 2.37459 13.5 3.11797 13.5H11.8819C12.6253 13.5 13.1088 12.7177 12.7763 12.0528Z",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), xe = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "AlertStatusHeavy",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M7.13381 3.00139L1.36522 13.0003C0.980609 13.6669 1.46175 14.5 2.23141 14.5H13.7686C14.5382 14.5 15.0194 13.6669 14.6348 13.0003L8.86619 3.00139C8.48136 2.33435 7.51864 2.33435 7.13381 3.00139Z",
          stroke: "currentColor",
          strokeWidth: "1.4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M8 9V6M8 12V11.994",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), pe = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ArrowDownLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M7.66663 3V13M7.66663 13L11.6666 8.33333M7.66663 13L3.66663 8.33333",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), je = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ArrowDownHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M8 3V13M8 13L12 9M8 13L4 9",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), ge = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ArrowLeftLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M13 7.66666L3 7.66666M3 7.66666L7.66667 11.6667M3 7.66666L7.66667 3.66666",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), ye = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ArrowLeftHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M13 7.99998L3 7.99998M3 7.99998L7 12M3 7.99998L7 3.99998",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), He = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ArrowRightLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M3 7.66666L13 7.66666M13 7.66666L8.33333 11.6667M13 7.66666L8.33333 3.66666",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Ve = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ArrowRightHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M3 8L13 8M13 8L9 12M13 8L9 4",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Ee = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ArrowUpLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M7.66666 13V3M7.66666 3L11.6667 7.66667M7.66666 3L3.66666 7.66667",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), we = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ArrowUpHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M8 13V3M8 3L12 7M8 3L4 7",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Ie = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "AudioLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M14.5 9.5V7.5C14.5 7.5 14.5 7.5 14.5 7.5C14.5 7.49994 14.5 1.5 8.00001 1.5C1.5 1.5 1.5 7.5 1.5 7.5C1.5 7.5 1.5 7.5 1.5 7.5V9.5M14.5 9.5V13C14.5 13.8284 13.8284 14.5 13 14.5V14.5C12.1716 14.5 11.5 13.8284 11.5 13V11.5C11.5 10.3954 12.3954 9.5 13.5 9.5H14.5ZM1.5 9.5V13C1.5 13.8284 2.17157 14.5 3 14.5V14.5C3.82843 14.5 4.5 13.8284 4.5 13V11.5C4.5 10.3954 3.60457 9.5 2.5 9.5H1.5Z",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Be = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "AudioHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M14 9V7C14 7 14 7 14 7C14 6.99998 14 2 8 2C2.00001 2 2 6.99997 2 7C2 7 2 7 2 7V9M14 9V12.5C14 13.3284 13.3284 14 12.5 14V14C11.6716 14 11 13.3284 11 12.5V11C11 9.89543 11.8954 9 13 9H14ZM2 9V12.5C2 13.3284 2.67157 14 3.5 14V14C4.32843 14 5 13.3284 5 12.5V11C5 9.89543 4.10457 9 3 9H2Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Re = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "BasketLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M4.50003 5.5H2.65304C2.04449 5.5 1.57703 6.03899 1.66309 6.64142L2.37738 11.6414C2.44775 12.1341 2.86968 12.5 3.36733 12.5H12.6327C13.1304 12.5 13.5523 12.1341 13.6227 11.6414L14.337 6.64142C14.423 6.03899 13.9556 5.5 13.347 5.5H11.5M4.50003 5.5L6.50003 2.5M4.50003 5.5H11.5M11.5 5.5L9.50003 2.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), me = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "BasketHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M3.99997 6H2.3257C1.66132 6 1.18166 6.63591 1.36418 7.27472L2.79275 12.2747C2.9154 12.704 3.30779 13 3.75427 13H12.2457C12.6921 13 13.0845 12.704 13.2072 12.2747L14.6358 7.27472C14.8183 6.6359 14.3386 6 13.6742 6H12M3.99997 6L6.00003 2M3.99997 6H12M12 6L10 2",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), be = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "CalendarLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M11.5 4.50001V3.50001M11.5 3.50001H12.5C13.0523 3.50001 13.5 3.94772 13.5 4.50001V6.50001M11.5 3.50001V1.50001M11.5 3.50001H4.5M4.5 3.50001H3.5C2.94772 3.50001 2.5 3.94772 2.5 4.50001V6.50001M4.5 3.50001V4.50001M4.5 3.50001V1.50001M2.5 6.50001V12.5C2.5 13.0523 2.94771 13.5 3.5 13.5H12.5C13.0523 13.5 13.5 13.0523 13.5 12.5V6.50001M2.5 6.50001H13.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Ze = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "CalendarHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M11 5V4M11 4H13C13.5523 4 14 4.44772 14 5V8M11 4V2M11 4H5M5 4H3C2.44772 4 2 4.44772 2 5V8M5 4V5M5 4V2M2 8V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V8M2 8H14",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), _e = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "CheckLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M3.49994 7.50002L6.49994 10.5L12.4999 4.50002",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), We = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "CheckHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M3 8L6 12L13 5",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Te = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ChevronDownLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M3.5 5.5L7.25671 9.67412C7.65395 10.1155 8.34605 10.1155 8.74329 9.67412L12.5 5.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Se = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ChevronDownHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M3 5L7.23178 10.0781C7.63157 10.5579 8.36843 10.5579 8.76822 10.0781L13 5",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Pe = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ChevronLeftLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M10.5 3.5L6.32588 7.25671C5.8845 7.65395 5.8845 8.34605 6.32588 8.74329L10.5 12.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Ae = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ChevronLeftHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M11 3L5.92186 7.23178C5.44211 7.63157 5.44211 8.36843 5.92187 8.76822L11 13",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Oe = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ChevronLeftEndLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M10.4999 3.5L6.32582 7.25671C5.88444 7.65395 5.88444 8.34605 6.32582 8.74329L10.4999 12.5M2.49994 3.5V12.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), De = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ChevronLeftEndHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M12 3L6.92186 7.23178C6.44211 7.63157 6.44211 8.36843 6.92187 8.76822L12 13M2 3V13",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Fe = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ChevronRightLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M5.5 3.5L9.5 8L5.5 12.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Ue = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ChevronRightHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M5 3L10.0781 7.23178C10.5579 7.63157 10.5579 8.36843 10.0781 8.76822L5 13",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), $e = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ChevronRightEndLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M5.5 3.5L9.5 8L5.5 12.5M12.5 3.5V12.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Ye = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ChevronRightEndHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M2 3L7.07814 7.23178C7.55789 7.63157 7.55789 8.36843 7.07813 8.76822L2 13M12 3V13",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Ne = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ChevronUpLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M3.5 10.5L7.25671 6.32588C7.65395 5.8845 8.34605 5.8845 8.74329 6.32588L12.5 10.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), qe = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ChevronUpHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M3 11L7.23178 5.92186C7.63157 5.44211 8.36843 5.44211 8.76822 5.92187L13 11",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), ze = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ColumnsLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M6.5 3.5H3.5V5.5M6.5 3.5V12.5M6.5 3.5H9.5M6.5 12.5H3.5V5.5M6.5 12.5H9.5M9.5 3.5H12.5V5.5M9.5 3.5V12.5M9.5 12.5H12.5V5.5M3.5 5.5H12.5",
        stroke: "currentColor",
        strokeLinejoin: "round"
      }
    )
  }
), Ge = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ColumnsHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M6 3H2V6M6 3V13M6 3H10M6 13H2V6M6 13H10M10 3H14V6M10 3V13M10 13H14V6M2 6H14",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinejoin: "round"
      }
    )
  }
), Je = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "CopyLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M6.5 6.5V9.33333C6.5 9.88561 6.94772 10.3333 7.5 10.3333H13.5C14.0523 10.3333 14.5 9.88561 14.5 9.33333V3.5C14.5 2.94772 14.0523 2.5 13.5 2.5H7.5C6.94772 2.5 6.5 2.94772 6.5 3.5V6.5ZM6.5 6.5H3.5C2.94772 6.5 2.5 6.94772 2.5 7.5V13.5C2.5 14.0523 2.94772 14.5 3.5 14.5H9.5C10.0523 14.5 10.5 14.0523 10.5 13.5V10.3333",
        stroke: "currentColor"
      }
    )
  }
), Ke = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "CopyHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M6.5 7V9C6.5 9.55228 6.94772 10 7.5 10H13C13.5523 10 14 9.55228 14 9V4C14 3.44772 13.5523 3 13 3H7.5C6.94772 3 6.5 3.44772 6.5 4V7ZM6.5 7H4C3.44772 7 3 7.44772 3 8V13C3 13.5523 3.44772 14 4 14H9C9.55228 14 10 13.5523 10 13V10",
        stroke: "currentColor",
        strokeWidth: "2"
      }
    )
  }
), Xe = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "CreativeLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M5.49997 12.5L1.49997 14.5L3.49997 10.5M5.49997 12.5L7.49997 10.5M5.49997 12.5L3.49997 10.5M3.49997 10.5L5.49997 8.5M5.49997 8.5L4.49997 7.5M5.49997 8.5L6.49997 9.5M8.49997 5.50004L11.5 2.50001C12.0523 1.94772 12.9477 1.94772 13.5 2.5V2.5C14.0523 3.05229 14.0523 3.94771 13.5 4.5L10.5 7.5M8.49997 5.50004L4.49997 1.5L1.49997 4.5L2.49997 5.50004M8.49997 5.50004L10.5 7.5M10.5 7.5L14.5 11.5L11.5 14.5L10.5 13.5M7.49997 10.5L6.49997 9.5M7.49997 10.5L8.49997 11.5M10.5 3.5L12.5 5.50004M2.49997 5.50004L4.00001 4M2.49997 5.50004L4.49997 7.5M4.49997 7.5L5.49997 6.5M6.49997 9.5L7.99997 8M8.49997 11.5L9.49997 10.5M8.49997 11.5L10.5 13.5M10.5 13.5L12 12",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Qe = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "CreativeHeavy",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M5 9L3 11L1 15L5 13L7 11M5 9L1 5L5 1L9 5M5 9L7 11M9 5L12 2C12.5523 1.44772 13.4477 1.44772 14 2V2C14.5523 2.55228 14.5523 3.44772 14 4L11 7M9 5L11 7M11 7L15 11L11 15L7 11",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M11 3L13 5M9.5 12.5L10.5 11.5M6 10L7.5 8.5M7.5 11.5L8.5 10.5M4.5 8.5L5.5 7.5M4.5 5.5L3 7",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), e5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "CrossLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M12 4L8 8M4 12L8 8M8 8L4 4M8 8L12 12",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), r5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "CrossHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M12 4L8 8M4 12L8 8M8 8L4 4M8 8L12 12",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), o5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "CrowdLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M9.5 14.5V13.5C9.5 12.3954 10.3954 11.5 11.5 11.5V11.5C12.6046 11.5 13.5 12.3954 13.5 13.5V14.5M2.5 14.5V13.5C2.5 12.3954 3.39543 11.5 4.5 11.5V11.5C5.60457 11.5 6.5 12.3954 6.5 13.5V14.5M15.5 4.5C15.5 5.05228 15.0523 5.5 14.5 5.5C13.9477 5.5 13.5 5.05228 13.5 4.5C13.5 3.94772 13.9477 3.5 14.5 3.5C15.0523 3.5 15.5 3.94772 15.5 4.5ZM9 4.5C9 5.05228 8.55228 5.5 8 5.5C7.44772 5.5 7 5.05228 7 4.5C7 3.94772 7.44772 3.5 8 3.5C8.55228 3.5 9 3.94772 9 4.5ZM2.5 4.5C2.5 5.05228 2.05228 5.5 1.5 5.5C0.947715 5.5 0.5 5.05228 0.5 4.5C0.5 3.94772 0.947715 3.5 1.5 3.5C2.05228 3.5 2.5 3.94772 2.5 4.5ZM5.5 8.5C5.5 9.05228 5.05228 9.5 4.5 9.5C3.94772 9.5 3.5 9.05228 3.5 8.5C3.5 7.94772 3.94772 7.5 4.5 7.5C5.05228 7.5 5.5 7.94772 5.5 8.5ZM12.5 8.5C12.5 9.05228 12.0523 9.5 11.5 9.5C10.9477 9.5 10.5 9.05228 10.5 8.5C10.5 7.94772 10.9477 7.5 11.5 7.5C12.0523 7.5 12.5 7.94772 12.5 8.5Z",
        stroke: "currentColor",
        strokeLinecap: "round"
      }
    )
  }
), n5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "CrowdHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M9 15V14C9 12.8954 9.89543 12 11 12V12C12.1046 12 13 12.8954 13 14V15M3 15V14C3 12.8954 3.89543 12 5 12V12C6.10457 12 7 12.8954 7 14V15M12 8C12 8.55228 11.5523 9 11 9C10.4477 9 10 8.55228 10 8C10 7.44772 10.4477 7 11 7C11.5523 7 12 7.44772 12 8ZM6 8C6 8.55228 5.55228 9 5 9C4.44772 9 4 8.55228 4 8C4 7.44772 4.44772 7 5 7C5.55228 7 6 7.44772 6 8ZM3 4C3 4.55228 2.55228 5 2 5C1.44772 5 1 4.55228 1 4C1 3.44772 1.44772 3 2 3C2.55228 3 3 3.44772 3 4ZM9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4ZM15 4C15 4.55228 14.5523 5 14 5C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3C14.5523 3 15 3.44772 15 4Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), t5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "DownloadLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M7.99994 2.5V9.5M7.99994 9.5L11.4999 6.5M7.99994 9.5L4.49994 6.5M3.49994 12.5H12.4999",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), i5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "DownloadHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M7.99994 2L8 10M8 10L11 7M8 10L5 7M4 13H12",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), s5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "DragLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M4 3.5H2.5V5M2.5 6V8M2.5 12V13.5H4M5 13.5H7M2.5 9V11M8 13.5H10M12.5 12V13.5H11M13.5 2.5V10.5H5.5V2.5H13.5Z",
        stroke: "currentColor",
        strokeLinejoin: "round"
      }
    )
  }
), c5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "DragHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M3 4H1V6M1 7V9M1 13V15H3M4 15H6M1 10V12M7 15H9M12 13V15H10M15 1V11H5V1H15Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinejoin: "round"
      }
    )
  }
), l5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "DuoLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M1.5 12.5V10.5C1.5 9.39543 2.39543 8.5 3.5 8.5H4.5C5.60457 8.5 6.5 9.39543 6.5 10.5V12.5M9.5 12.5V10.5C9.5 9.39543 10.3954 8.5 11.5 8.5H12.5C13.6046 8.5 14.5 9.39543 14.5 10.5V12.5M5.5 4.5C5.5 5.32843 4.82843 6 4 6C3.17157 6 2.5 5.32843 2.5 4.5C2.5 3.67157 3.17157 3 4 3C4.82843 3 5.5 3.67157 5.5 4.5ZM13.5 4.5C13.5 5.32843 12.8284 6 12 6C11.1716 6 10.5 5.32843 10.5 4.5C10.5 3.67157 11.1716 3 12 3C12.8284 3 13.5 3.67157 13.5 4.5Z",
        stroke: "currentColor",
        strokeLinecap: "round"
      }
    )
  }
), a5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "DuoHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M1.5 12.5V10.5C1.5 9.39543 2.39543 8.5 3.5 8.5H4.5C5.60457 8.5 6.5 9.39543 6.5 10.5V12.5M9.5 12.5V10.5C9.5 9.39543 10.3954 8.5 11.5 8.5H12.5C13.6046 8.5 14.5 9.39543 14.5 10.5V12.5M5.5 4.5C5.5 5.32843 4.82843 6 4 6C3.17157 6 2.5 5.32843 2.5 4.5C2.5 3.67157 3.17157 3 4 3C4.82843 3 5.5 3.67157 5.5 4.5ZM13.5 4.5C13.5 5.32843 12.8284 6 12 6C11.1716 6 10.5 5.32843 10.5 4.5C10.5 3.67157 11.1716 3 12 3C12.8284 3 13.5 3.67157 13.5 4.5Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
      }
    )
  }
), d5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "EditLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M11.5001 2.5L13.5001 4.5L5.50006 12.5L2.50006 13.5L3.50006 10.5L11.5001 2.5Z",
        stroke: "currentColor",
        strokeLinejoin: "round"
      }
    )
  }
), u5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "EditHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M12 2L14 4L5 13L2 14L3 11L12 2Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinejoin: "round"
      }
    )
  }
), C5 = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "EllipsisHorizontalLight",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M14 8C14 8.55228 13.5523 9 13 9C12.4477 9 12 8.55228 12 8C12 7.44772 12.4477 7 13 7C13.5523 7 14 7.44772 14 8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M4 8C4 8.55228 3.55228 9 3 9C2.44772 9 2 8.55228 2 8C2 7.44772 2.44772 7 3 7C3.55228 7 4 7.44772 4 8Z",
          fill: "currentColor"
        }
      )
    ]
  }
), f5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "EllipsisHorizontalHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 8C1 6.89543 1.89543 6 3 6C4.10457 6 5 6.89543 5 8C5 9.10457 4.10457 10 3 10C1.89543 10 1 9.10457 1 8ZM6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8ZM11 8C11 6.89543 11.8954 6 13 6C14.1046 6 15 6.89543 15 8C15 9.10457 14.1046 10 13 10C11.8954 10 11 9.10457 11 8Z",
        fill: "currentColor"
      }
    )
  }
), h5 = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "EllipsisVerticalLight",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4Z",
          fill: "currentColor"
        }
      )
    ]
  }
), v5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "EllipsisVerticalHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 3C6 1.89543 6.89543 1 8 1C9.10457 1 10 1.89543 10 3C10 4.10457 9.10457 5 8 5C6.89543 5 6 4.10457 6 3ZM6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8ZM6 13C6 11.8954 6.89543 11 8 11C9.10457 11 10 11.8954 10 13C10 14.1046 9.10457 15 8 15C6.89543 15 6 14.1046 6 13Z",
        fill: "currentColor"
      }
    )
  }
), L5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ExitLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M2.50003 2.5V13.5M5.50003 7.5H12.5M12.5 7.5L9.50003 5.5M12.5 7.5L9.50003 9.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), k5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ExitHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M1.99997 4V12M5.99997 7.99998H13M13 7.99998L9.99997 4.99999M13 7.99998L9.99997 11",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), M5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "FavoriteLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M8.00004 14.5C5.51807 12.2405 1.5 9.1963 1.5 5.49999C1.5 1.94896 5.83386 0.956224 8.00004 3.5C10.1662 0.956224 14.5 1.94895 14.5 5.49999C14.5 9.19023 10.4879 12.2523 8.00004 14.5Z",
        stroke: "currentColor",
        strokeLinejoin: "round"
      }
    )
  }
), x5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "FavoriteHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M8.00004 14C5.70899 11.9991 2 9.30329 2 6.02999C2 2.88534 6.00049 2.00622 8.00004 4.25888C9.99959 2.00622 14 2.88534 14 6.02998C14 9.2979 10.2965 12.0096 8.00004 14Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinejoin: "round"
      }
    )
  }
), p5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "FileLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M8.33334 1.66666H5.66667C4.5621 1.66666 3.66667 2.56209 3.66667 3.66666V12.3333C3.66667 13.4379 4.5621 14.3333 5.66667 14.3333H10.3333C11.4379 14.3333 12.3333 13.4379 12.3333 12.3333V5.66666M8.33334 1.66666L12.3333 5.66666M8.33334 1.66666V5.66666H12.3333",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), j5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "FileHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M8 2H6C4.89543 2 4 2.89543 4 4V12C4 13.1046 4.89543 14 6 14H10C11.1046 14 12 13.1046 12 12V6M8 2L12 6M8 2V6H12",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), g5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "FilterLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M4.50006 4.5H11.5001M10.5001 7.5H5.50006M6.50006 10.5H9.50006",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), y5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "FilterHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M4 5H12M11 8H5M6 11H10",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), H5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ForbiddenLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M11.8891 4.11091C14.037 6.2588 14.037 9.7412 11.8891 11.8891C9.7412 14.037 6.2588 14.037 4.11091 11.8891M11.8891 4.11091C9.7412 1.96303 6.2588 1.96303 4.11091 4.11091C1.96303 6.2588 1.96303 9.7412 4.11091 11.8891M11.8891 4.11091L4.11091 11.8891",
        stroke: "currentColor"
      }
    )
  }
), V5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ForbiddenHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M11.5355 4.46447C13.4882 6.41709 13.4882 9.58291 11.5355 11.5355C9.58291 13.4882 6.41709 13.4882 4.46447 11.5355M11.5355 4.46447C9.58291 2.51184 6.41709 2.51184 4.46447 4.46447C2.51184 6.41709 2.51184 9.58291 4.46447 11.5355M11.5355 4.46447L4.46447 11.5355",
        stroke: "currentColor",
        strokeWidth: "2"
      }
    )
  }
), E5 = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "Global",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M11.0001 0C13.7615 0 16 2.23898 16 5.00091V11.0001C15.9935 12.9408 14.8652 14.7024 13.1052 15.5195C13.1217 15.3616 13.13 15.203 13.1301 15.0442C13.1301 14.9598 13.1277 14.8761 13.1229 14.7931C13.1167 14.7651 13.1167 14.7371 13.1167 14.709C13.1125 14.654 13.1094 14.599 13.1032 14.5451C13.099 14.5077 13.0959 14.489 13.0897 14.4413C13.0835 14.3936 13.0762 14.3313 13.07 14.2981C13.0637 14.2649 13.0586 14.2389 13.0503 14.1943C13.042 14.1497 13.0326 14.0978 13.0243 14.0615C13.016 14.0252 13.0088 13.9951 12.9984 13.9525C12.988 13.91 12.9766 13.8633 12.9662 13.827C12.9558 13.7906 12.9465 13.7564 12.934 13.717C12.9216 13.6775 12.9091 13.636 12.8967 13.5987C12.8842 13.5613 12.8718 13.526 12.8573 13.4876C12.8427 13.4492 12.8293 13.4119 12.8147 13.3745C12.8002 13.3371 12.7846 13.2956 12.7691 13.2635C12.7535 13.2313 12.739 13.196 12.7224 13.1597C12.7058 13.1234 12.6871 13.086 12.6705 13.0497C12.6539 13.0134 12.6383 12.9833 12.6197 12.9459C12.601 12.9085 12.5813 12.8722 12.5616 12.8359L12.5076 12.7404C12.4858 12.7093 12.4651 12.673 12.4423 12.6367L12.3852 12.5474C12.3613 12.5152 12.3375 12.4789 12.3126 12.4436L12.2534 12.3617C12.2275 12.3295 12.2005 12.2932 12.1735 12.2579L12.1144 12.1842C12.0843 12.152 12.0552 12.1157 12.0252 12.0804L11.9681 12.0171C11.9318 11.9798 11.8986 11.9424 11.8643 11.9061L11.8177 11.8594C11.7253 11.766 11.635 11.6757 11.5313 11.5896C13.2564 9.91349 13.629 7.2822 12.4371 5.19289C12.3734 5.07666 12.3043 4.9632 12.2296 4.85251C13.3159 4.17797 13.1084 2.53937 13.1084 2.53937H8.00778C7.96213 2.53937 7.91336 2.53937 7.86668 2.53937C4.95516 2.53937 2.5949 4.90008 2.5949 7.81217C2.5949 10.7243 4.95516 13.085 7.86668 13.085C8.0939 13.085 8.54834 13.085 8.54834 13.085C8.96733 13.0838 9.37566 13.2169 9.71351 13.4648C9.75501 13.4949 9.79236 13.527 9.83386 13.5582C9.87536 13.5893 9.91479 13.6246 9.95318 13.662C10.5714 14.2798 10.7114 15.23 10.2976 16H6.78451C6.63043 15.711 6.5499 15.3884 6.55003 15.0608C6.5491 14.7808 6.60782 14.5038 6.72226 14.2483L5.84035 13.8498L4.35977 13.1804C4.27799 13.3659 4.20867 13.5565 4.15226 13.7512C4.11214 13.8965 4.07756 14.0442 4.04851 14.1943L4.03709 14.2545C4.02983 14.295 4.0236 14.3303 4.01634 14.3759C4.00908 14.4216 4.00285 14.4683 3.99767 14.515C3.99006 14.5496 3.98625 14.5842 3.98625 14.6188C3.97795 14.6713 3.9738 14.7243 3.9738 14.7775C3.9738 14.8004 3.9738 14.8222 3.9738 14.845C3.96758 14.9176 3.96758 14.9903 3.96758 15.0629C3.96774 15.347 3.99414 15.6305 4.04643 15.9097C1.69667 15.4527 0.000191008 13.3944 0 11.0001V5.00091C0 2.23898 2.23855 0 4.99994 0H11.0001Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M9.70862 5.91128C9.82897 6.03356 9.93757 6.16689 10.033 6.3095C10.7189 7.32457 10.6298 8.67558 9.8164 9.59169C9.00299 10.5078 7.67221 10.756 6.58337 10.1946C5.49453 9.63327 4.92457 8.40518 5.1987 7.21105C5.47283 6.01693 6.52132 5.1605 7.74593 5.13043H7.95384C8.61553 5.16327 9.24121 5.44169 9.70862 5.91128Z",
          fill: "currentColor"
        }
      )
    ]
  }
), w5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "HomeLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M6.50006 13.5H2.50006V6.5L8.00002 2.5L13.5001 6.5V13.5H9.50006V11.5C9.50006 10.5 9.50006 9.5 8.00006 9.5C6.50006 9.5 6.50006 10.5 6.50006 11.5V13.5Z",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), I5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "HomeHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M6 14H2V6.36364L7.99996 2L14 6.36364V14H10V12C10 10.8954 9.10457 10 8 10C6.89543 10 6 10.8954 6 12V14Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), B5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "InfoStatusLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M7.5 7.5V10.5M7.5 4.5V4.506M13.5 7.5C13.5 10.8137 10.8137 13.5 7.5 13.5C4.18629 13.5 1.5 10.8137 1.5 7.5C1.5 4.18629 4.18629 1.5 7.5 1.5C10.8137 1.5 13.5 4.18629 13.5 7.5Z",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), R5 = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "InfoStatusHeavy",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M8 8V11M8 5V5.006",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8Z",
          stroke: "currentColor",
          strokeWidth: "1.4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), m5 = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ListLight",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M12.5 1.5H3.5C2.94772 1.5 2.5 1.94772 2.5 2.5V13.5C2.5 14.0523 2.94771 14.5 3.5 14.5H12.5C13.0523 14.5 13.5 14.0523 13.5 13.5V2.5C13.5 1.94772 13.0523 1.5 12.5 1.5Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M5.5 4.5H10.5M5.5 7.5H10.5M5.5 10.5H10.5",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), b5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ListHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M6 5H10M6 8H10M6 11H10M4 14H12C12.5523 14 13 13.5523 13 13V3C13 2.44772 12.5523 2 12 2H4C3.44772 2 3 2.44772 3 3V13C3 13.5523 3.44772 14 4 14Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Z5 = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "LocationLight",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M12.5 6C12.5 9.33333 8 14.5 8 14.5C8 14.5 3.5 9.33333 3.5 6C3.5 3.79086 5.51472 1.5 8 1.5C10.4853 1.5 12.5 3.79086 12.5 6Z",
          stroke: "currentColor",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M9.5 6C9.5 6.82843 8.82843 7.5 8 7.5C7.17157 7.5 6.5 6.82843 6.5 6C6.5 5.17157 7.17157 4.5 8 4.5C8.82843 4.5 9.5 5.17157 9.5 6Z",
          stroke: "currentColor"
        }
      )
    ]
  }
), _5 = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "LocationHeavy",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M13 5.84615C13 9.4359 8 15 8 15C8 15 3 9.4359 3 5.84615C3 3.46708 5.23858 1 8 1C10.7614 1 13 3.46708 13 5.84615Z",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M9 6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6C7 5.44772 7.44772 5 8 5C8.55228 5 9 5.44772 9 6Z",
          stroke: "currentColor",
          strokeWidth: "2"
        }
      )
    ]
  }
), W5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "LocationZoomLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M7.50004 5V7.5M7.50004 7.5L7.5 10M7.50004 7.5H10M7.50004 7.5H5M12.5 7.5C12.5 10.2614 10.2614 12.5 7.5 12.5C4.73858 12.5 2.5 10.2614 2.5 7.5C2.5 4.73858 4.73858 2.5 7.5 2.5C10.2614 2.5 12.5 4.73858 12.5 7.5Z",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), T5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "LocationZoomHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M8 5V8M8 8V11M8 8H11M8 8H5M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), S5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "MailLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M1.49997 3.33334L14.5 3.50001M1.49997 3.33334V12.5H14.5V3.50001M1.49997 3.33334L7.99997 8.50001L14.5 3.50001",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), P5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "MailHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M2 4H14M2 4V12H14V4M2 4L8 9L14 4",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), A5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "MinusLight",
    children: /* @__PURE__ */ e.jsx("path", { d: "M3.5 7.5H12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })
  }
), O5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "MinusHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M3 8H13",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), D5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "NotificationLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M14.5 13.5H1.50005C1.50005 10.5 3.49998 10.5 3.49998 10.5L3.49999 5.5C3.49999 5.5 3.50004 1.5 8.00005 1.5C12.5 1.5 12.5 5.5 12.5 5.5V10.5C12.5 10.5 14.5 10.5 14.5 13.5Z",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), F5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "NotificationHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M14.0001 13H2C2 10 3.99993 10 3.99993 10L3.99994 6.00002C3.99994 3.79087 5.79082 2 7.99997 2C10.2091 2 12 3.79087 12 6.00003V10C12 10 14.0001 10 14.0001 13Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), U5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "OpenExternalLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M9.5 2.5H13.5M13.5 2.5V6.5M13.5 2.5L5.5 10.5M7.5 4.5H4.5C3.39543 4.5 2.5 5.39543 2.5 6.5V11.5C2.5 12.6046 3.39543 13.5 4.5 13.5H9.5C10.6046 13.5 11.5 12.6046 11.5 11.5V8.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), $5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "OpenExternalHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M10 2H14M14 2V6M14 2L6 10M7 4L4 4C2.89543 4 2 4.89543 2 6V12C2 13.1046 2.89543 14 4 14H10C11.1046 14 12 13.1046 12 12V9",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Y5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "PadlockClosedLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M5.5 7.5H4.5C3.94772 7.5 3.5 7.94772 3.5 8.5V13.5C3.5 14.0523 3.94772 14.5 4.5 14.5H11.5C12.0523 14.5 12.5 14.0523 12.5 13.5V8.5C12.5 7.94772 12.0523 7.5 11.5 7.5H10.5M5.5 7.5V5.50002C5.5 5.50001 5.5 5.50001 5.5 5.5C5.5 5.49965 5.50026 3 8.00004 3C10.5 3 10.5 5.5 10.5 5.5C10.5 5.5 10.5 5.5 10.5 5.5V7.5M5.5 7.5H10.5",
        stroke: "currentColor",
        strokeLinecap: "round"
      }
    )
  }
), N5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "PadlockClosedHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M6 6H4C3.44772 6 3 6.44772 3 7V13C3 13.5523 3.44772 14 4 14H12C12.5523 14 13 13.5523 13 13V7C13 6.44772 12.5523 6 12 6H10M6 6V4.00002C6 4.00001 6 4.00001 6 4C6 3.99956 6.0003 2 8.00004 2C10 2 10 4 10 4C10 4 10 4 10 4V6M6 6H10",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
      }
    )
  }
), q5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "PlayLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.49994 2.5V14.5L12.4999 8L3.49994 2.5Z",
        stroke: "currentColor",
        strokeLinejoin: "round"
      }
    )
  }
), z5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "PlayHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 2V14L13 8L3 2Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinejoin: "round"
      }
    )
  }
), G5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "PlusLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M7.50001 3.5V7.49999M7.50006 11.5L7.50001 7.49999M7.50001 7.49999H11.5001M7.50001 7.49999H3.50006",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), J5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "PlusHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M7.99995 4V7.99999M8 12L7.99995 7.99999M7.99995 7.99999H12M7.99995 7.99999H4",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), K5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "RadioLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M4.49994 5.5H3.33331C2.22874 5.5 1.33331 6.39543 1.33331 7.5V12.5C1.33331 13.6046 2.22874 14.5 3.33331 14.5H12.4999C13.6045 14.5 14.4999 13.6046 14.4999 12.5V7.5C14.4999 6.39543 13.6045 5.5 12.4999 5.5H4.49994ZM4.49994 5.5L6.49994 2.5M4.49994 5.5L1.49994 1.5M4.49994 10.5V10.5C5.05222 10.5 5.49994 10.0523 5.49994 9.5V9.5C5.49994 8.94772 5.05222 8.5 4.49994 8.5V8.5C3.94765 8.5 3.49994 8.94772 3.49994 9.5V9.5C3.49994 10.0523 3.94765 10.5 4.49994 10.5ZM9.49994 11.5H10.4999C11.0522 11.5 11.4999 11.0523 11.4999 10.5V9.5C11.4999 8.94772 11.0522 8.5 10.4999 8.5H9.49994C8.94765 8.5 8.49994 8.94772 8.49994 9.5V10.5C8.49994 11.0523 8.94765 11.5 9.49994 11.5Z",
        stroke: "currentColor",
        strokeLinecap: "round"
      }
    )
  }
), X5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "RadioHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M5 6H3C1.89543 6 1 6.89543 1 8V13C1 14.1046 1.89543 15 3 15H13C14.1046 15 15 14.1046 15 13V8C15 6.89543 14.1046 6 13 6H5ZM5 6L7 3M5 6L2 2M4.5 10V10C4.77614 10 5 9.77614 5 9.5V9.5C5 9.22386 4.77614 9 4.5 9V9C4.22386 9 4 9.22386 4 9.5V9.5C4 9.77614 4.22386 10 4.5 10ZM9 12H11C11.5523 12 12 11.5523 12 11V10C12 9.44772 11.5523 9 11 9H9C8.44772 9 8 9.44772 8 10V11C8 11.5523 8.44772 12 9 12Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
      }
    )
  }
), Q5 = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "RefreshLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M11.5 3.5C8.49994 0.5 2.99994 3 3.49995 7.5M3.49995 7.5L5.49994 5.5M3.49995 7.5L1.49994 5.5M12.4999 7.49998L10.4999 9.49999M12.4999 7.49998L14.4999 9.49998M12.4999 7.49998C12.9999 12 7.49994 14.5 4.49992 11.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), er = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "RefreshHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M11 3.00003C8.50003 0.50003 2.00005 2 3 8M3 8L5 6M3 8L1 6M13 8L11 10M13 8L15 10M13 8C14 14 7.49997 15.5 4.99997 13",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), rr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "RoadsideLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M3.49997 2.5V2.5C2.3954 2.5 1.49997 3.39543 1.49997 4.5V9.5C1.49997 10.6046 2.3954 11.5 3.49997 11.5V11.5M3.49997 2.5V0.5M3.49997 2.5H12.5M12.5 2.5H12.6667C13.7712 2.5 14.6667 3.39543 14.6667 4.5V9.5C14.6667 10.6046 13.7712 11.5 12.6667 11.5H12.5M12.5 2.5V0.5M12.5 11.5H3.49997M12.5 11.5V13.5M12.5 15.3333V13.5M3.49997 11.5V13.5M3.49997 15.3333V13.5M2.00001 13.5H3.49997M3.49997 13.5H12.5M12.5 13.5H14",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), or = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "RoadsideHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M4.00004 2V2C2.89547 2 2 2.89543 2 4V8C2 9.10457 2.89547 10 4.00004 10V10M4.00004 2V1M4.00004 2H12M12 2V2C13.1046 2 14 2.89541 14 3.99996V8C14 9.10457 13.1046 10 12 10V10M12 2V1M12 10H4.00004M12 10V13M12 15V13M4.00004 10V13M4.00004 15V13M2.00002 13H4.00004M4.00004 13H12M12 13H14",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), nr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "SalesForceLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M12.8482 4.43841C12.371 4.43841 11.9551 4.58157 11.5461 4.71791C11.0689 3.89304 10.1758 3.34767 9.21463 3.34767C8.46475 3.34767 7.78303 3.68853 7.29902 4.16573C6.75365 3.48402 5.92878 3 4.97438 3C3.38599 3 2.02257 4.30207 2.02257 5.89046C2.02257 6.29267 2.16573 6.7017 2.30207 7.11072C1.9094 7.32597 1.58154 7.64245 1.35257 8.02728C1.12359 8.4121 1.00185 8.85123 1 9.29902C1 10.6624 2.09756 11.835 3.4678 11.835C3.67231 11.835 3.87682 11.835 4.01317 11.7668C4.28585 12.7962 5.31524 13.5529 6.54914 13.5529C7.70805 13.5529 8.66926 12.8644 9.01011 11.9032C9.35779 12.0463 9.69864 12.1827 10.0395 12.1827C10.9325 12.1827 11.7506 11.685 12.1596 10.9488C12.371 11.0033 12.5891 11.0033 12.78 11.0033C14.5593 11.0033 15.9977 9.57852 15.9977 7.73108C16.0658 5.89046 14.6342 4.43841 12.8482 4.43841Z",
        stroke: "currentColor"
      }
    )
  }
), tr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "SalesForceHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M12.0583 4.36305C11.6129 4.36305 11.2248 4.49871 10.843 4.62791C10.3976 3.84625 9.56412 3.32946 8.66699 3.32946C7.9671 3.32946 7.33083 3.65245 6.87908 4.10465C6.37007 3.45866 5.60019 3 4.70942 3C3.22693 3 1.9544 4.23385 1.9544 5.73902C1.9544 6.12016 2.08801 6.50775 2.21527 6.89535C1.84878 7.09932 1.54277 7.39922 1.32906 7.76388C1.11535 8.12855 1.00173 8.54466 1 8.96899C1 10.261 2.02439 11.3721 3.30328 11.3721C3.49416 11.3721 3.68504 11.3721 3.81229 11.3075C4.06679 12.2829 5.02755 13 6.17919 13C7.26084 13 8.15798 12.3475 8.47611 11.4367C8.8006 11.5724 9.11873 11.7016 9.43687 11.7016C10.2704 11.7016 11.0339 11.23 11.4157 10.5323C11.6129 10.584 11.8165 10.584 11.9947 10.584C13.6553 10.584 14.9978 9.23385 14.9978 7.4832C15.0614 5.73902 13.7253 4.36305 12.0583 4.36305Z",
        stroke: "currentColor",
        strokeWidth: "2"
      }
    )
  }
), ir = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "SearchLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M11.0355 11.0355C12.9881 9.08291 12.9881 5.91709 11.0355 3.96447C9.0829 2.01184 5.91708 2.01184 3.96446 3.96447C2.01184 5.91709 2.01184 9.08291 3.96446 11.0355C5.91708 12.9882 9.0829 12.9882 11.0355 11.0355ZM11.0355 11.0355L13.5 13.5",
        stroke: "currentColor",
        strokeLinecap: "round"
      }
    )
  }
), sr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "SearchHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M10.5356 10.5355C12.4882 8.58291 12.4882 5.41709 10.5356 3.46447C8.58293 1.51184 5.41709 1.51184 3.46447 3.46447C1.51184 5.41709 1.51184 8.58291 3.46447 10.5355C5.41709 12.4882 8.58293 12.4882 10.5356 10.5355ZM10.5356 10.5355L14 14",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
      }
    )
  }
), cr = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "SendLight",
    children: [
      /* @__PURE__ */ e.jsx("path", { d: "M13 8.5H4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M13.5 8.50004L2.52508 13.5001L4.5 8.50004L2.5 3.5L13.5 8.50004Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), lr = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "UnsendLight",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.51484 11.7763L2.73239 13.9551C2.54685 14.0396 2.32856 14.003 2.18073 13.8626C2.03291 13.7222 1.98516 13.506 2.06006 13.3164L3.96197 8.50122L2.03578 3.68571C1.95994 3.4961 2.00702 3.27943 2.15471 3.1384C2.3024 2.99737 2.52101 2.96033 2.70692 3.04483L3.94007 3.60535L4.53994 4.97648L3.42671 4.47047L4.83851 8H5.86273L6.30023 9H4.84014L3.4453 12.5314L7.11398 10.86L7.51484 11.7763ZM10.2452 10.5324L13.7074 8.95506C13.8857 8.8738 14.0001 8.69583 14.0001 8.49984C14 8.30384 13.8854 8.12597 13.707 8.04487L8.02745 5.46326L8.62732 6.83439L11.1917 8H9.13727L9.57477 9H11.1967L9.84432 9.61611L10.2452 10.5324Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ e.jsx("path", { d: "M5 2L10 14", stroke: "currentColor" })
    ]
  }
), ar = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ShareLight",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M9.5 5.5V5.5C10.6046 5.5 11.5 6.39543 11.5 7.5V11.5C11.5 12.6046 10.6046 13.5 9.5 13.5H5.5C4.39543 13.5 3.5 12.6046 3.5 11.5V7.5C3.5 6.39543 4.39543 5.5 5.5 5.5V5.5",
          stroke: "currentColor",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M7.5 1.5L5.5 3.5M7.5 1.5L9.5 3.5M7.5 1.5V10.5",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), dr = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ShareHeavy",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M10 7V7C11.1046 7 12 7.89543 12 9V12C12 13.1046 11.1046 14 10 14H6C4.89543 14 4 13.1046 4 12V9C4 7.89543 4.89543 7 6 7V7",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M8 11V1M8 1L6 3M8 1L10 3",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), ur = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "TargetLight",
    children: [
      /* @__PURE__ */ e.jsx("circle", { cx: "8", cy: "8", r: "6.5", stroke: "currentColor" }),
      /* @__PURE__ */ e.jsx("circle", { cx: "8", cy: "8", r: "3.5", stroke: "currentColor" }),
      /* @__PURE__ */ e.jsx("circle", { cx: "8", cy: "8", r: "0.5", stroke: "currentColor" })
    ]
  }
), Cr = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "TargetHeavy",
    children: [
      /* @__PURE__ */ e.jsx("circle", { cx: "8", cy: "8", r: "7", stroke: "currentColor", strokeWidth: "2" }),
      /* @__PURE__ */ e.jsx("circle", { cx: "8", cy: "8", r: "3", stroke: "currentColor", strokeWidth: "2" }),
      /* @__PURE__ */ e.jsx("circle", { cx: "8", cy: "8", r: "0.5", stroke: "currentColor" })
    ]
  }
), fr = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "TimeLight",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M13.5 8C13.5 11.0376 11.0376 13.5 8 13.5C4.96243 13.5 2.5 11.0376 2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C11.0376 2.5 13.5 4.96243 13.5 8Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.jsx("path", { d: "M7.5 5V8.5H9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })
    ]
  }
), hr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "TimeHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M8 5V8H10M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), vr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "TrackerLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M1.49994 11.5L4.80199 7.37244C5.17431 6.90703 5.86852 6.86858 6.28996 7.29003L7.73635 8.73641C8.14825 9.14831 8.82362 9.12237 9.20271 8.6801L14.4999 2.5M14.4999 13.5H1.49994",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Lr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "TrackerHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M2 11L5 6L9 10L14 3M14 14H2",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), kr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "TrashLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M2.5 2.5H3.5M13.5 2.5H12.5M12.5 2.5V13.5C12.5 14.0523 12.0523 14.5 11.5 14.5H4.5C3.94772 14.5 3.5 14.0523 3.5 13.5V2.5M12.5 2.5H10.5M3.5 2.5H5.5M5.5 2.5V1.5H10.5V2.5M5.5 2.5H10.5M9.5 5.5V11.5M6.5 11.5V5.5",
        stroke: "currentColor",
        strokeLinecap: "square",
        strokeLinejoin: "round"
      }
    )
  }
), Mr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "TrashHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M2 2H3M14 2H13M13 2V14C13 14.5523 12.5523 15 12 15H4C3.44772 15 3 14.5523 3 14V2M13 2H11M3 2H5M5 2V1H11V2M5 2H11M10 6V11M6 11V6",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "square",
        strokeLinejoin: "round"
      }
    )
  }
), xr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "TrioLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M9.5 13.5V12.5C9.5 11.3954 10.3954 10.5 11.5 10.5H12.5C13.6046 10.5 14.5 11.3954 14.5 12.5V13.5M1.5 13.5V12.5C1.5 11.3954 2.39543 10.5 3.5 10.5H4.5C5.60457 10.5 6.5 11.3954 6.5 12.5V13.5M9.5 3C9.5 3.82843 8.82843 4.5 8 4.5C7.17157 4.5 6.5 3.82843 6.5 3C6.5 2.17157 7.17157 1.5 8 1.5C8.82843 1.5 9.5 2.17157 9.5 3ZM5.5 7C5.5 7.82843 4.82843 8.5 4 8.5C3.17157 8.5 2.5 7.82843 2.5 7C2.5 6.17157 3.17157 5.5 4 5.5C4.82843 5.5 5.5 6.17157 5.5 7ZM13.5 7C13.5 7.82843 12.8284 8.5 12 8.5C11.1716 8.5 10.5 7.82843 10.5 7C10.5 6.17157 11.1716 5.5 12 5.5C12.8284 5.5 13.5 6.17157 13.5 7Z",
        stroke: "currentColor",
        strokeLinecap: "round"
      }
    )
  }
), pr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "TrioHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M9.5 14.5V13.5C9.5 12.3954 10.3954 11.5 11.5 11.5H12.5C13.6046 11.5 14.5 12.3954 14.5 13.5V14.5M1.5 14.5V13.5C1.5 12.3954 2.39543 11.5 3.5 11.5H4.5C5.60457 11.5 6.5 12.3954 6.5 13.5V14.5M9.5 2.5C9.5 3.32843 8.82843 4 8 4C7.17157 4 6.5 3.32843 6.5 2.5C6.5 1.67157 7.17157 1 8 1C8.82843 1 9.5 1.67157 9.5 2.5ZM5.5 7.5C5.5 8.32843 4.82843 9 4 9C3.17157 9 2.5 8.32843 2.5 7.5C2.5 6.67157 3.17157 6 4 6C4.82843 6 5.5 6.67157 5.5 7.5ZM13.5 7.5C13.5 8.32843 12.8284 9 12 9C11.1716 9 10.5 8.32843 10.5 7.5C10.5 6.67157 11.1716 6 12 6C12.8284 6 13.5 6.67157 13.5 7.5Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
      }
    )
  }
), jr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "UndoLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M5.5 12.5H11.5C12.0523 12.5 12.5 12.0523 12.5 11.5V7.5C12.5 6.94772 12.0523 6.5 11.5 6.5H3.5M3.5 6.5L6.5 3.5M3.5 6.5L6.5 9.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), gr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "UndoHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M6 13H12C12.5523 13 13 12.5523 13 12V7C13 6.44772 12.5523 6 12 6H3M3 6L6 3M3 6L6 9",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), yr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "UploadLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M7.50003 10.5V3.5M7.50003 3.5L9.50003 5.5M7.50003 3.5L5.50003 5.5M2.50003 12.5L12.5 12.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Hr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "UploadHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M7.99994 10L8 2M8 2L11 5M8 2L5 5M4 13H12",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Vr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ViewLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M8.00003 12.5C12.0501 12.5 15.5 9.33333 15.5 8C15.5 6.66667 12.0501 3.5 7.99999 3.5M8.00003 12.5C3.94994 12.5 0.500031 9.33333 0.500031 8C0.500031 6.66667 3.9499 3.5 7.99999 3.5M8.00003 12.5C10.2092 12.5 12.5 10.4853 12.5 8C12.5 5.51471 10.2091 3.5 7.99999 3.5M8.00003 12.5C5.79089 12.5 3.50003 10.4853 3.50003 8C3.50003 5.51473 5.79085 3.5 7.99999 3.5M9.50003 8C9.50003 8.82843 8.82846 9.5 8.00003 9.5C7.1716 9.5 6.50003 8.82843 6.50003 8C6.50003 7.17157 7.1716 6.5 8.00003 6.5C8.82846 6.5 9.50003 7.17157 9.50003 8Z",
        stroke: "currentColor"
      }
    )
  }
), Er = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "ViewHeavy",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M8 12C11.7801 12 15 9.18519 15 8C15 6.81481 11.78 4 7.99996 4M8 12C4.21992 12 1 9.18519 1 8C1 6.81481 4.21988 4 7.99996 4M8 12C10.0619 12 12 10.2091 12 8C12 5.79085 10.0618 4 7.99996 4M8 12C5.93814 12 4 10.2091 4 8C4 5.79087 5.9381 4 7.99996 4M7.5 7.5V7.5C7.22386 7.77614 7.22386 8.22386 7.5 8.5V8.5C7.77614 8.77614 8.22386 8.77614 8.5 8.5V8.5C8.77614 8.22386 8.77614 7.77614 8.5 7.5V7.5C8.22386 7.22386 7.77614 7.22386 7.5 7.5Z",
        stroke: "currentColor",
        strokeWidth: "2"
      }
    )
  }
), wr = (r) => /* @__PURE__ */ e.jsx(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "WarningStatusLight",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M7.5 7.5V4.5M7.5 10.5V10.494M13.5 7.5C13.5 4.18629 10.8137 1.5 7.5 1.5C4.18629 1.5 1.5 4.18629 1.5 7.5C1.5 10.8137 4.18629 13.5 7.5 13.5C10.8137 13.5 13.5 10.8137 13.5 7.5Z",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Ir = (r) => /* @__PURE__ */ e.jsxs(
  n,
  {
    ...r,
    style: { fill: "none" },
    viewBox: "0 0 16 16",
    vectorEffect: "non-scaling-stroke",
    id: "WarningStatusHeavy",
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M8 8V5M8 11V10.994",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8Z",
          stroke: "currentColor",
          strokeWidth: "1.4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  ve as AccountDropdownHeavyIcon,
  he as AccountDropdownLightIcon,
  fe as AccountHeavyIcon,
  Ce as AccountLightIcon,
  ke as AccountsHeavyIcon,
  Le as AccountsLightIcon,
  xe as AlertStatusHeavyIcon,
  Me as AlertStatusLightIcon,
  je as ArrowDownHeavyIcon,
  pe as ArrowDownLightIcon,
  ye as ArrowLeftHeavyIcon,
  ge as ArrowLeftLightIcon,
  Ve as ArrowRightHeavyIcon,
  He as ArrowRightLightIcon,
  we as ArrowUpHeavyIcon,
  Ee as ArrowUpLightIcon,
  Be as AudioHeavyIcon,
  Ie as AudioLightIcon,
  me as BasketHeavyIcon,
  Re as BasketLightIcon,
  Ze as CalendarHeavyIcon,
  be as CalendarLightIcon,
  We as CheckHeavyIcon,
  _e as CheckLightIcon,
  Se as ChevronDownHeavyIcon,
  Te as ChevronDownLightIcon,
  De as ChevronLeftEndHeavyIcon,
  Oe as ChevronLeftEndLightIcon,
  Ae as ChevronLeftHeavyIcon,
  Pe as ChevronLeftLightIcon,
  Ye as ChevronRightEndHeavyIcon,
  $e as ChevronRightEndLightIcon,
  Ue as ChevronRightHeavyIcon,
  Fe as ChevronRightLightIcon,
  qe as ChevronUpHeavyIcon,
  Ne as ChevronUpLightIcon,
  Ge as ColumnsHeavyIcon,
  ze as ColumnsLightIcon,
  Ke as CopyHeavyIcon,
  Je as CopyLightIcon,
  Qe as CreativeHeavyIcon,
  Xe as CreativeLightIcon,
  r5 as CrossHeavyIcon,
  e5 as CrossLightIcon,
  n5 as CrowdHeavyIcon,
  o5 as CrowdLightIcon,
  i5 as DownloadHeavyIcon,
  t5 as DownloadLightIcon,
  c5 as DragHeavyIcon,
  s5 as DragLightIcon,
  a5 as DuoHeavyIcon,
  l5 as DuoLightIcon,
  u5 as EditHeavyIcon,
  d5 as EditLightIcon,
  f5 as EllipsisHorizontalHeavyIcon,
  C5 as EllipsisHorizontalLightIcon,
  v5 as EllipsisVerticalHeavyIcon,
  h5 as EllipsisVerticalLightIcon,
  k5 as ExitHeavyIcon,
  L5 as ExitLightIcon,
  x5 as FavoriteHeavyIcon,
  M5 as FavoriteLightIcon,
  j5 as FileHeavyIcon,
  p5 as FileLightIcon,
  y5 as FilterHeavyIcon,
  g5 as FilterLightIcon,
  V5 as ForbiddenHeavyIcon,
  H5 as ForbiddenLightIcon,
  E5 as GlobalIcon,
  I5 as HomeHeavyIcon,
  w5 as HomeLightIcon,
  R5 as InfoStatusHeavyIcon,
  B5 as InfoStatusLightIcon,
  b5 as ListHeavyIcon,
  m5 as ListLightIcon,
  _5 as LocationHeavyIcon,
  Z5 as LocationLightIcon,
  T5 as LocationZoomHeavyIcon,
  W5 as LocationZoomLightIcon,
  P5 as MailHeavyIcon,
  S5 as MailLightIcon,
  O5 as MinusHeavyIcon,
  A5 as MinusLightIcon,
  F5 as NotificationHeavyIcon,
  D5 as NotificationLightIcon,
  $5 as OpenExternalHeavyIcon,
  U5 as OpenExternalLightIcon,
  N5 as PadlockClosedHeavyIcon,
  Y5 as PadlockClosedLightIcon,
  z5 as PlayHeavyIcon,
  q5 as PlayLightIcon,
  J5 as PlusHeavyIcon,
  G5 as PlusLightIcon,
  X5 as RadioHeavyIcon,
  K5 as RadioLightIcon,
  er as RefreshHeavyIcon,
  Q5 as RefreshLightIcon,
  or as RoadsideHeavyIcon,
  rr as RoadsideLightIcon,
  tr as SalesForceHeavyIcon,
  nr as SalesForceLightIcon,
  sr as SearchHeavyIcon,
  ir as SearchLightIcon,
  cr as SendLightIcon,
  dr as ShareHeavyIcon,
  ar as ShareLightIcon,
  Cr as TargetHeavyIcon,
  ur as TargetLightIcon,
  hr as TimeHeavyIcon,
  fr as TimeLightIcon,
  Lr as TrackerHeavyIcon,
  vr as TrackerLightIcon,
  Mr as TrashHeavyIcon,
  kr as TrashLightIcon,
  pr as TrioHeavyIcon,
  xr as TrioLightIcon,
  gr as UndoHeavyIcon,
  jr as UndoLightIcon,
  lr as UnsendLightIcon,
  Hr as UploadHeavyIcon,
  yr as UploadLightIcon,
  Er as ViewHeavyIcon,
  Vr as ViewLightIcon,
  Ir as WarningStatusHeavyIcon,
  wr as WarningStatusLightIcon
};
//# sourceMappingURL=index.js.map
